export const PINCODE_SEARCH_FIELD_KEYS = {
  LATITUDE: ["latitude", "lat", "hubLatitude", "hub_latitude"],
  LONGITUDE: ["longitude", "lng", "hubLongitude", "hub_longitude"],
  PINCODE: ["pincode", "pinCode", "pin"],
  HUB_NAME: "hub_name",
  SERVICE_TYPE: "serviceType",
  SERVICEABLE: "serviceable",
};

export const PINCODE_SEARCH_ROUTE = {
  MAP_PATH: "/pincode-map",
  PINCODE_QUERY_PARAM: "pincode",
};

export const PINCODE_SEARCH_MAP = {
  INDIA_CENTER: [22.5937, 78.9629],
  MINI_MAP_DEFAULT_ZOOM: 5,
  MINI_MAP_FOCUS_ZOOM: 10,
  MINI_MAP_HEIGHT: 340,
  MINI_MAP_WIDTH: "100%",
  COORDINATE_PRECISION: 5,
  PIN_POPUP_OPEN_DELAY_MS: 120,
  TILE_URL: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
  TILE_ATTRIBUTION:
    "&copy; <a href=\"https://www.openstreetmap.org/\">OpenStreetMap</a> contributors &copy; CARTO",
  MINI_MAP_DEFAULT_KEY: "india-default",
  MINI_PIN_ICON: {
    className: "",
    html: "<div class=\"pincode-mini-pin\"></div>",
    iconSize: [14, 14],
    iconAnchor: [7, 7],
    popupAnchor: [0, -10],
  },
  PIN_POPUP_MAX_WIDTH: 260,
};

export const PINCODE_SEARCH_COPY = {
  PAGE_TITLE: "Pincode Search",
  OPEN_MAP_BUTTON: "Open Pincode Map",
  NAVIGATE_TO_MAP_BUTTON: "Navigate to map",
  BACK_BUTTON: "Back",
  HUB_COUNT_SUFFIX: "hubs",
  HUB_NAME_FALLBACK: "Mapped Hub",
  HUB_FALLBACK_PREFIX: "Hub",
  SERVICES_SUFFIX: "services",
  DEFAULT_SERVICE_TYPE: "SERVICE",
  FILTERED_NON_SERVICEABLE_SERVICE_TYPE: "MCN/3PL",
  EMPTY_STATE_WITHOUT_PINCODE:
    "Run a pincode search from global search to view results.",
  MINI_MAP_PREVIEW_COPY: "Quick location preview for this pincode.",
  MINI_MAP_DEFAULT_COPY:
    "Showing default map view. Open full map for exact pincode focus.",
  MINI_MAP_POPUP_SUBTITLE: "Mapped pincode",
  MINI_MAP_POPUP_LOCATION_FALLBACK: "Mapped pincode",
  MINI_MAP_POPUP_COORDINATE_FALLBACK: "Coordinates unavailable",
  LOCATION_SEPARATOR: ", ",
  NO_MAPPED_SERVICES_PREFIX: "No mapped services were returned for",
};

export const PINCODE_SEARCH_COVERAGE_CHIPS = [
  {
    key: "courier",
    label: "Courier",
    keywords: ["courier"],
  },
  {
    key: "ecomm",
    label: "E-commerce",
    keywords: ["e-com", "ecomm", "ecommerce"],
  },
  {
    key: "mcn",
    label: "Courier (MCN / 3PL)",
    keywords: ["mcn", "3pl"],
  },
];

export const PINCODE_SEARCH_STATUS = {
  SERVICEABLE: {
    className: "serviceable",
    label: "Serviceable",
  },
  NON_SERVICEABLE: {
    className: "non-serviceable",
    label: "Not serviceable",
  },
  MIXED: {
    className: "mixed",
    label: "Partially serviceable",
  },
};

export const PINCODE_SEARCH_NAVIGATION = {
  BACK_HISTORY_LIMIT: 1,
  BACK_STEP: -1,
};

export const buildPincodeMapUrl = (pincode) => {
  if (!pincode) return PINCODE_SEARCH_ROUTE.MAP_PATH;

  return `${PINCODE_SEARCH_ROUTE.MAP_PATH}?${
    PINCODE_SEARCH_ROUTE.PINCODE_QUERY_PARAM
  }=${encodeURIComponent(pincode)}`;
};

export const getNoResultsDescription = (pincode) => {
  if (!pincode) return PINCODE_SEARCH_COPY.EMPTY_STATE_WITHOUT_PINCODE;

  return `${PINCODE_SEARCH_COPY.NO_MAPPED_SERVICES_PREFIX} ${pincode}.`;
};

export const getHubFallbackName = (index) =>
  `${PINCODE_SEARCH_COPY.HUB_FALLBACK_PREFIX} ${index + 1}`;

export const getHubCountLabel = (count) =>
  `${count} ${PINCODE_SEARCH_COPY.HUB_COUNT_SUFFIX}`;

export const getServiceCountLabel = (count) =>
  `${count} ${PINCODE_SEARCH_COPY.SERVICES_SUFFIX}`;
